import { isArray } from 'lodash-es';
import fonts from '../../../utils/Fonts';

import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './utils';
import spacer from './SpacerElement/fields';
import starrating from './StarRatingElement/fields';
import counter from './CounterElement/fields';
import statbox from './StatBox/fields';
import text from './TextElement/fields';
import actionpanel from './ActionPanelElement/fields';
import horizontalscroller from './HorizontalScrollerElement/fields';
import linechart from './LineChartElement/fields';
import radarchart from './RadarChartElement/fields';
import qrcode from './QRCodeElement/fields';
import signature from './SignatureElement/fields';
import version from './VersionElement/fields';
import bottomsheet from './BottomSheetElement/fields';
import recordnavigator from './RecordNavigatorElement/fields';
import calendar from './CalendarElement/fields';
import muscleheatmap from './MuscleHeatMap/fields';
import expochannel from './ExpoChannelElement/fields';
import image from './ImageElement/fields';
import video from './VideoElement/fields';
import icon from './IconElement/fields';
import panel from './PanelElement/fields';
import layout from './LayoutElement/fields';
import component from './ComponentElement/fields';
import schematiceditor from './SchematicEditorElement/fields';
import productoptions from './ProductOptionsElement/fields';
import button from './ButtonElement/fields';
import list from './ListElement/fields';
import login from './LoginElement/fields';
import resetpassword from './ResetPasswordElement/fields';
import signuporloginmethod from './SignupOrLoginMethod/fields';
import signup from './SignupElement/fields';
import fileupload from './FileUploadElement/fields';
import radiobuttongroup from './RadioButtonGroup/fields';
import formtextinput from './FormTextInputElement/fields';
import formdatetimeinput from './FormInputDateTimePickerElement/fields';
import formswitchinput from './FormSwitchInputElement/fields';
import formlistinput from './FormListInputElement/fields';
import formdropdowninput from './FormDropDownInputElement/fields';
import formmodallist from './FormModalListElement/fields';
import webviewer from './WebViewerElement/fields';
import stripe from './StripeElement/fields';
import mediaviewer from './MediaViewerElement/fields';
import weekview from './WeekViewElement/fields';
import exerciselist from './ExerciseListElement/fields';
import addressautocomplete from './FormAddressAutoCompleteElement/fields';
import activityindicator from './ActivityIndicatorElement/fields';
import validationmessage from './ValidationMessage/fields';

const elements = {
  base: {
    properties: [
      {
        name: 'identifier',
        label: 'Friendly Name',
        description: '',
        editor: 'textbox',
        type: 'string',
        default: 'A friendly name for this element',
        group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
      },
      {
        name: 'text',
        label: 'Text',
        description: '',
        editor: 'textbox',
        type: 'string',
        default: 'change this text',
        group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
      },
      {
        name: 'mockData',
        label: 'Mock Data',
        description:
          'Mock data to display in this element when viewing in the app designer',
        editor: 'textarea',
        type: 'string',
        default: 'My Mock Data',
        group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
      },
      {
        name: 'color',
        label: 'Color',
        description: '',
        editor: 'color',
        type: 'string',
        default: '#000000',
        group: ELEMENT_ATTRIBUTE_GROUP.COLORS
      },
      {
        name: 'backgroundColor',
        label: 'Background Color',
        description: '',
        editor: 'color',
        type: 'string',
        default: '#ffffff',
        group: ELEMENT_ATTRIBUTE_GROUP.COLORS
      },
      {
        name: 'opacity',
        label: 'Background Opacity',
        description: '',
        editor: 'number',
        type: 'number',
        default: 1,
        group: ELEMENT_ATTRIBUTE_GROUP.VISIBILITY
      },
      {
        name: 'fontFamily',
        label: 'Font Family',
        description: '',
        options: [{ label: 'Default', value: 'default' }],
        editor: 'dropdown',
        type: 'string',
        group: ELEMENT_ATTRIBUTE_GROUP.FONTS
      },
      {
        name: 'font',
        label: 'Font Settings',
        description: '',
        editor: 'fontsize',
        type: 'font',
        default: 16,
        group: ELEMENT_ATTRIBUTE_GROUP.FONTS
      },
      {
        name: 'size',
        label: 'Size',
        description: '',
        editor: 'number',
        type: 'string',
        default: 16,
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      {
        name: 'width',
        label: 'Width',
        description: '',
        editor: 'number',
        type: 'string',
        default: 250,
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      {
        name: 'height',
        label: 'Height',
        description: '',
        editor: 'number',
        type: 'string',
        default: 50,
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      {
        name: 'iconsize',
        label: 'Icon Size',
        description: '',
        editor: 'iconsize',
        type: 'number',
        default: 6,
        group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
      },
      {
        name: 'alignment',
        label: 'Alignment',
        description: '',
        editor: 'alignment',
        type: 'string',
        default: 'justify-center',
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      {
        name: 'margin',
        label: 'Margin',
        description: '',
        editor: 'boundary',
        type: 'string',
        default: '0 0 0 0',
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      {
        name: 'padding',
        label: 'Padding',
        description: '',
        editor: 'boundary',
        type: 'string',
        default: '0 0 0 0',
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      {
        name: 'border',
        label: 'Border',
        description: '',
        editor: 'border',
        type: 'string',
        default: 0,
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      {
        name: 'source',
        label: 'Source',
        description: '',
        editor: 'image',
        mediaLibraryStoreIn: 'custom_folder',
        mediaLibraryPath: 'apps',
        type: 'string',
        group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
      },
      {
        name: 'icon',
        label: 'Icon',
        description: '',
        editor: 'icon',
        type: 'string',
        default: 'DocumentIcon',
        group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
      },
      {
        name: 'url',
        label: 'Url',
        description: '',
        editor: 'textbox',
        type: 'string',
        default: 'https://vimeo.com/253989945',
        group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
      },
      {
        name: 'layout',
        label: 'Layout Container',
        description:
          'A layout container to place this component inside. If the layout container does not render due to the current device and screen orientation, the element will attempt to render outside of the layout contained as normal, unless you specifically hide it for a particular device type and orientation.',
        editor: 'dropdown',
        options: [],
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      }
    ]
  },
  activityindicator,
  validationmessage,
  addressautocomplete,
  starrating,
  spacer,
  counter,
  statbox,
  text,
  actionpanel,
  horizontalscroller,
  linechart,
  radarchart,
  qrcode,
  signature,
  version,
  bottomsheet,
  recordnavigator,
  calendar,
  muscleheatmap,
  expochannel,
  image,
  video,
  icon,
  panel,
  layout,
  component,
  schematiceditor,
  productoptions,
  button,
  list,
  login,
  resetpassword,
  signuporloginmethod,
  signup,
  fileupload,
  radiobuttongroup,
  formtextinput,
  formdatetimeinput,
  formswitchinput,
  formlistinput,
  formdropdowninput,
  formmodallist,
  webviewer,
  stripe,
  mediaviewer,
  weekview,
  exerciselist
};

/*
    Purpose:

    Given the name of a screen element, i.e. text or image or something more advanced,
    create an object that contains the fields needed to describe this element.
    This object will then be stored in the database like this:

    The sort order of the elements is based on their position in the elements array

    app: {
      app_screens: [
        { 
          type: 'the screen type', 
          sortOrder: 0,
          elements: [
            { 
              name: 'text',
              color: 'red',
              margin: '0 auto'
            },
            { 
              name: 'icon',
              icon: 'DocumentIcon',
              color: 'green',
            }
          ]
        }
      ]
    }
*/
const buildElement = (name, theme) => {
  let element = elements[name];
  if (!element) {
    return {};
  }

  const docElement = {
    name
  };

  element.properties.forEach(property => {
    if (property.name) {
      if (property.type === 'font') {
        docElement[`${property.name}Size`] = property.default || 14;
        docElement[`${property.name}TextDecoration`] = 'none';
        docElement[`${property.name}FontStyle`] = 'normal';
        docElement[`${property.name}FontWeight`] = 'normal';
      } else {
        docElement[property.name] = property.default ? property.default : '';
      }
    } else {
      const baseProp = elements.base.properties.find(p => p.name === property);

      if (baseProp.type === 'font') {
        docElement[`${baseProp.name}Size`] = property.default || 14;
        docElement[`${baseProp.name}TextDecoration`] = 'none';
        docElement[`${baseProp.name}FontStyle`] = 'normal';
        docElement[`${baseProp.name}FontWeight`] = 'normal';
      } else {
        docElement[baseProp.name] = baseProp.default ? baseProp.default : '';
      }
    }
  });

  docElement.id = `${docElement.name}_${Date.now()}`;
  return applyThemeToElement(docElement, theme);
};

const applyThemeToElement = (element, theme) => {
  switch (element.name) {
    case 'button':
      return applyThemeToButtonElement(element, theme);
    case 'text':
      return applyThemeToTextElement(element, theme);
    default:
      return element;
  }
};

const applyThemeToButtonElement = (element, theme = {}) => {
  [
    'mode',
    'width',
    'font',
    'fontFamily',
    'fontWeight',
    'fontSize',
    'fontTextDecoration',
    'padding',
    'margin',
    'color',
    'backgroundColor'
  ].forEach(property => {
    const themeValue =
      theme[
        `button${property.substring(0, 1).toUpperCase()}${property.substring(
          1
        )}`
      ];
    if (themeValue && themeValue !== '') {
      element[property] = themeValue;
    }
  });
  return element;
};

const applyThemeToTextElement = (element, theme = {}) => {
  [
    'font',
    'fontFamily',
    'fontWeight',
    'fontSize',
    'fontTextDecoration',
    'padding',
    'margin',
    'color',
    'backgroundColor'
  ].forEach(property => {
    const themeValue =
      theme[
        `text${property.substring(0, 1).toUpperCase()}${property.substring(1)}`
      ];
    if (themeValue && themeValue !== '') {
      element[property] = themeValue;
    }
  });
  return element;
};

/*

  Purpose:

  Builds a list of Formik style field information, in the same way that contentType section group fields are structured

  i.e. [
    {
      name: 'backgroundColor',
      enableCustomLabel: false,
      customLabel: '',
      editable: true,
      hideInReadOnlyMode: false,
      type: 'text',
      editor: 'color',
      displayConditions: [
        {
          name: 'useBackgroundImage',
          value: false,
          operator: '='
        }
      ]
    }
  ]

*/
const buildElementFormFields = ({
  elementInstance,
  document,
  elementDefinition
}) => {
  let element = elementDefinition || elements[elementInstance.name];

  if (!element) {
    return {};
  }

  const fields = [];

  /* property example 

      {
        name: 'color',
        label: 'Color',
        description: '',
        editor: 'color',
        type: 'string',
        default: 'black'
      },

    */

  let elementProps = [
    ...element.properties.filter(e => e.name !== 'layout' && e !== 'layout')
  ];

  if (element.properties.find(e => e.name === 'layout' || e === 'layout')) {
    const layoutFields = [];
    layoutFields.push({
      name: 'layoutContainersPerDeviceOrientation',
      label: 'Use different Layout Containers',
      default: false,
      description:
        'If set to true, will enable this element to use different layout containers, based on device and orientation',
      editor: 'switch',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      name: 'layout',
      label: 'Layout Container - (All Devices & Orientations)',
      description:
        'A layout container to place this component inside on all devices and orientations',
      editor: 'dropdown',
      default: ' ',
      displayWhen: [
        {
          field: 'layoutContainersPerDeviceOrientation',
          operator: 'DOES_NOT_EQUAL',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      name: 'layoutTabletPortrait',
      label: 'Layout Container - Tablet Portrait',
      description:
        'A layout container to place this component inside on a Tablet in Portrait',
      editor: 'dropdown',
      default: ' ',
      displayWhen: [
        {
          field: 'layoutContainersPerDeviceOrientation',
          operator: '=',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      name: 'layoutTabletLandscape',
      label: 'Layout Container - Tablet Landscape',
      description:
        'A layout container to place this component inside on a Tablet in Landscape',
      editor: 'dropdown',
      default: ' ',
      displayWhen: [
        {
          field: 'layoutContainersPerDeviceOrientation',
          operator: '=',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      name: 'layoutPhonePortrait',
      label: 'Layout Container - Phone Portrait',
      description:
        'A layout container to place this component inside on a Phone in Portrait',
      editor: 'dropdown',
      default: ' ',
      displayWhen: [
        {
          field: 'layoutContainersPerDeviceOrientation',
          operator: '=',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      name: 'layoutPhoneLandscape',
      label: 'Layout Container - Phone Landscape',
      description:
        'A layout container to place this component inside on a Phone in Landscape',
      editor: 'dropdown',
      default: ' ',
      displayWhen: [
        {
          field: 'layoutContainersPerDeviceOrientation',
          operator: '=',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });

    layoutFields.push({
      label: 'Hide when Tablet (Portrait)',
      name: 'hideWhenTabletPortrait',
      description: 'Hide this element when on a Tablet in Portrait View',
      editor: 'switch',
      default: false,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      label: 'Hide when Tablet (Landscape)',
      name: 'hideWhenTabletLandscape',
      description: 'Hide this element when on a Tablet in Landscape View',
      editor: 'switch',
      default: false,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      label: 'Hide when Phone (Landscape)',
      name: 'hideWhenPhoneLandscape',
      description: 'Hide this element when on a Phone in Landscape View',
      editor: 'switch',
      default: false,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      label: 'Hide when Phone (Portrait)',
      name: 'hideWhenPhonePortrait',
      description: 'Hide this element when on a Phone in Portrait View',
      editor: 'switch',
      default: false,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });

    layoutFields.push({
      label: 'Layout Column - Tablet (Portrait)',
      name: 'layoutColumnTabletPortrait',
      default: 1,
      description:
        'The column index within the layout container, on a tablet in portrait orientation',
      editor: 'number',
      displayWhen: [
        {
          field: 'hideWhenTabletPortrait',
          operator: 'DOES_NOT_EQUAL',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      label: 'Layout Column - Tablet (Landscape)',
      name: 'layoutColumnTabletLandscape',
      default: 1,
      description:
        'The column index within the layout container, on a tablet in landscape orientation',
      editor: 'number',
      displayWhen: [
        {
          field: 'hideWhenTabletLandscape',
          operator: 'DOES_NOT_EQUAL',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      label: 'Layout Column - Phone (Portrait)',
      name: 'layoutColumnPhonePortrait',
      default: 1,
      description:
        'The column index within the layout container, on a phone in portrait orientation',
      editor: 'number',
      displayWhen: [
        {
          field: 'hideWhenPhonePortrait',
          operator: 'DOES_NOT_EQUAL',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    layoutFields.push({
      label: 'Layout Column - Phone (Landscape)',
      name: 'layoutColumnPhoneLandscape',
      default: 1,
      description:
        'The column index within the layout container, on a phone in landscape orientation',
      editor: 'number',
      displayWhen: [
        {
          field: 'hideWhenPhoneLandscape',
          operator: 'DOES_NOT_EQUAL',
          value: true
        }
      ],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    });
    elementProps = [...elementProps, ...layoutFields];
  }

  if (element.label !== 'Layout') {
    elementProps = [
      {
        label: 'Full Width',
        name: 'fullWidth',
        default: false,
        description:
          'If set, will occupy the full width of the container it is in, ignoring any manual width set on this element.',
        editor: 'switch',
        options: [],
        group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
      },
      ...elementProps
    ];
  }

  const conditionalDisplayFields = [
    {
      label: 'Conditional Display',
      name: 'conditionType',
      default: '',
      description:
        'Select a condition type to base the display of this element on.',
      editor: 'dropdown',
      options: [
        { label: '<Not Set>', value: '', sortOrder: 0 },
        {
          label: 'Document Value',
          value: 'document',
          sortOrder: 1
        },
        {
          label: 'Local Store',
          value: 'local',
          sortOrder: 2
        },
        {
          label: 'JSON',
          value: 'json',
          sortOrder: 3
        },
        { label: 'Has Stripe Role', value: 'hasStripeRole', sortOrder: 4 },
        {
          label: 'Does Not Have Stripe Role',
          value: 'doesNotHaveStripeRole',
          sortOrder: 5
        },
        {
          label: 'Has Firebase Role',
          sortOrder: 6,
          value: 'hasRole'
        },
        {
          label: 'Does Not Have Firebase Role',
          sortOrder: 7,
          value: 'doesNotHaveRole'
        },
        {
          label: 'Has Claim',
          sortOrder: 8,
          value: 'hasClaim'
        },
        {
          label: 'Does Not Have Claim',
          sortOrder: 9,
          value: 'doesNotHaveClaim'
        },
        {
          label: 'Is Logged In',
          sortOrder: 10,
          value: 'loggedIn'
        },
        {
          label: 'Is Not Logged In',
          sortOrder: 11,
          value: 'loggedOut'
        },
        {
          label: 'Has Purchased Product Id',
          sortOrder: 12,
          value: 'hasProductId'
        },
        {
          label: 'Has Not Purchased Product Id',
          sortOrder: 13,
          value: 'doesNotHaveProductId'
        },
        {
          label: 'Has Active Subscription Id',
          sortOrder: 14,
          value: 'hasActiveSubscription'
        },
        {
          label: 'Does Not Have Active Subscription Id',
          sortOrder: 15,
          value: 'doesNotHaveActiveSubscription'
        },
        {
          label: 'Has Content Type Read-Only Access',
          sortOrder: 16,
          value: 'contentTypeReadOnlyAccess'
        },
        {
          label: 'Has Content Type Read-Write Access',
          sortOrder: 17,
          value: 'contentTypeReadWriteAccess'
        },
        {
          label: 'Has No Content Type Read or Write Access',
          sortOrder: 18,
          value: 'contentTypeNoAccess'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Conditional Display Action',
      name: 'conditionDisplayAction',
      editor: 'dropdown',
      options: [
        { label: 'Hide the Element', value: 'hide' },
        { label: 'Show the Element', value: 'show' },
        { label: 'Disable the Element', value: 'disable' },
        { label: 'Enable the Element', value: 'enable' },
        { label: 'Change Button Text', value: 'text' }
      ],
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IS_NOT_EMPTY',
          value: ''
        }
      ],
      description: 'What to do when the condition is met',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Alternative Text',
      name: 'alternativeText',
      editor: 'textbox',
      default: '',
      description: 'The text to display when the condition is met',
      displayWhen: [
        {
          field: 'conditionalDisplayConditionType',
          operator: 'IS_NOT_EMPTY',
          value: ''
        },
        {
          field: 'conditionalDisplayAction',
          operator: '=',
          value: 'text'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Evaluate From',
      name: 'conditionValueSource',
      editor: 'dropdown',
      options: [
        { label: '<Not Set>', value: '' },
        { label: 'Static Value', value: 'static' },
        { label: 'Data Source', value: 'datasource' },
        { label: 'Local Store', value: 'local' }
      ],
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IN',
          value: [
            'hasStripeRole',
            'doesNotHaveStripeRole',
            'hasRole',
            'doesNotHaveRole',
            'hasClaim',
            'doesNotHaveClaim',
            'hasProductId',
            'doesNotHaveProductId',
            'hasActiveSubscription',
            'doesNotHaveActiveSubscription'
          ]
        }
      ],
      description:
        'Select where the value will come from that will be evaluated by the condition',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Value Data Source',
      name: 'conditionValueDataSourceId',
      editor: 'dropdown',
      description: 'The data source to use to get the value to compare against',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IN',
          value: [
            'hasStripeRole',
            'doesNotHaveStripeRole',
            'hasRole',
            'doesNotHaveRole',
            'hasClaim',
            'doesNotHaveClaim',
            'hasProductId',
            'doesNotHaveProductId',
            'hasActiveSubscription',
            'doesNotHaveActiveSubscription'
          ]
        },
        {
          field: 'conditionValueSource',
          operator: '=',
          value: 'datasource'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Value Data Source Field',
      name: 'conditionValueDataSourceField',
      editor: 'dropdown',
      description:
        'The field from the selected data source whose value, will be used to evaluate the condition',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'conditionValueDataSourceId']
      },
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IN',
          value: [
            'hasStripeRole',
            'doesNotHaveStripeRole',
            'hasRole',
            'doesNotHaveRole',
            'hasClaim',
            'doesNotHaveClaim',
            'hasProductId',
            'doesNotHaveProductId',
            'hasActiveSubscription',
            'doesNotHaveActiveSubscription'
          ]
        },
        {
          field: 'conditionValueSource',
          operator: '=',
          value: 'datasource'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Data Source',
      name: 'conditionDataSourceId',
      editor: 'dropdown',
      description: 'The data source to use for the condition.',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IN',
          value: [
            'document',
            'contentTypeNoAccess',
            'contentTypeReadOnlyAccess',
            'contentTypeReadWriteAccess'
          ]
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Data Source Field',
      name: 'conditionDataSourceField',
      editor: 'dropdown',
      description:
        'The field from the selected data source whose value, will be used to evaluate the condition',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'conditionDataSourceId']
      },
      displayWhen: [
        {
          field: 'conditionType',
          operator: '==',
          value: 'document'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Operator',
      name: 'conditionDataSourceOperator',
      editor: 'dropdown',
      description: 'The operator used to evaluate the condition',
      default: '=',
      options: [
        { label: 'Equal To', value: '=' },
        { label: 'Not Equal To', value: '!==' },
        { label: 'Greater Than', value: '>' },
        { label: 'Greater Than or Equal To', value: '>=' },
        { label: 'Less Than', value: '<' },
        { label: 'Less Than or Equal To', value: '<=' },
        { label: 'Is Empty', value: 'IS_EMPTY' },
        { label: 'Not Empty', value: 'IS_NOT_EMPTY' },
        { label: 'In', value: 'IN' },
        { label: 'Not In', value: 'NOT_IN' },
        { label: 'Starts With', value: 'STARTS_WITH' },
        { label: 'Does Not Start With', value: 'DOES_NOT_START_WITH' },
        { label: 'Ends With', value: 'ENDS_WITH' },
        { label: 'Does Not End With', value: 'DOES_NOT_END_WITH' },
        { label: 'Contains', value: 'CONTAINS' },
        { label: 'Does Not Contain', value: 'DOES_NOT_CONTAIN' },
        { label: 'Is On Date', value: 'ON_DATE' },
        { label: 'Is Not On Date', value: 'NOT_ON_DATE' },
        { label: 'Is After Date', value: 'AFTER' },
        { label: 'Is On or After Date', value: 'ON_OR_AFTER' },
        { label: 'Is Before Date', value: 'BEFORE' },
        { label: 'Is On or Before Date', value: 'ON_OR_BEFORE' }
      ],
      displayWhen: [
        {
          field: 'conditionType',
          operator: '==',
          value: 'document'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Document Value',
      name: 'conditionDataSourceValue',
      editor: 'textbox',
      description:
        'A value to compare the field value of the data source document against',
      default: '',
      displayWhen: [
        {
          field: 'conditionType',
          operator: '==',
          value: 'document'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Conditional Evaluation JSON',
      name: 'conditionJson',
      editor: 'textarea',
      description:
        'An array of [ { datasourceId, field, operator, value }]. datasourceId can be set to "user" to evaluate user fields. "value" can accept placeholders from any datasource in the form "${datasourceId.fieldName} is ${datasourceId.another}" allowing mixing of datasourceIds. Valid operators are = , !== , >, >=, < , <= , IS_EMPTY, IS_NOT_EMPTY, IN, NOT_IN, STARTS_WITH, DOES_NOT_START_WITH, ENDS_WITH, DOES_NOT_END_WITH, CONTAINS, DOES_NOT_CONTAIN, ON_DATE, NOT_ON_DATE, AFTER, BEFORE',
      default: '',
      displayWhen: [
        {
          field: 'conditionType',
          operator: '==',
          value: 'json'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Conditional Local Store Field',
      name: 'conditionLocalValueField',
      editor: 'textbox',
      description:
        'The field from the local store that the condition is based on',
      default: '',
      options: [],
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IN',
          value: [
            'hasStripeRole',
            'doesNotHaveStripeRole',
            'hasRole',
            'doesNotHaveRole',
            'hasClaim',
            'doesNotHaveClaim',
            'hasProductId',
            'doesNotHaveProductId',
            'hasActiveSubscription',
            'doesNotHaveActiveSubscription'
          ]
        },
        {
          field: 'conditionValueSource',
          operator: '=',
          value: 'local'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Conditional Local Store Field',
      name: 'conditionLocalField',
      editor: 'textbox',
      description:
        'The field from the local store that the condition is based on',
      default: '',
      options: [],
      displayWhen: [
        {
          field: 'conditionType',
          operator: '=',
          value: 'local'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Operator',
      name: 'conditionLocalOperator',
      editor: 'dropdown',
      description: 'The operator used to evaluate the condition',
      default: '=',
      options: [
        { label: 'Equal To', value: '=' },
        { label: 'Not Equal To', value: '!==' },
        { label: 'Greater Than', value: '>' },
        { label: 'Greater Than or Equal To', value: '>=' },
        { label: 'Less Than', value: '<' },
        { label: 'Less Than or Equal To', value: '<=' },
        { label: 'Is Empty', value: 'IS_EMPTY' },
        { label: 'Not Empty', value: 'IS_NOT_EMPTY' },
        { label: 'In', value: 'IN' },
        { label: 'Not In', value: 'NOT_IN' },
        { label: 'Starts With', value: 'STARTS_WITH' },
        { label: 'Does Not Start With', value: 'DOES_NOT_START_WITH' },
        { label: 'Ends With', value: 'ENDS_WITH' },
        { label: 'Does Not End With', value: 'DOES_NOT_END_WITH' },
        { label: 'Contains', value: 'CONTAINS' },
        { label: 'Does Not Contain', value: 'DOES_NOT_CONTAIN' },
        { label: 'Is On Date', value: 'ON_DATE' },
        { label: 'Is Not On Date', value: 'NOT_ON_DATE' },
        { label: 'Is After Date', value: 'AFTER' },
        { label: 'Is Before Date', value: 'BEFORE' }
      ],
      displayWhen: [
        {
          field: 'conditionType',
          operator: '=',
          value: 'local'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Value',
      name: 'conditionLocalValue',
      editor: 'textbox',
      description: 'The value to compare against',
      default: '',
      displayWhen: [
        {
          field: 'conditionType',
          operator: '==',
          value: 'local'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Value',
      name: 'conditionStaticValue',
      editor: 'textbox',
      description: 'The value to compare against',
      default: '',
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IN',
          value: [
            'hasStripeRole',
            'doesNotHaveStripeRole',
            'hasRole',
            'doesNotHaveRole',
            'hasClaim',
            'doesNotHaveClaim',
            'hasProductId',
            'doesNotHaveProductId',
            'hasActiveSubscription',
            'doesNotHaveActiveSubscription'
          ]
        },
        {
          field: 'conditionValueSource',
          operator: '==',
          value: 'static'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Condition Claim Name',
      name: 'conditionClaimName',
      editor: 'textbox',
      description: 'The value to compare against',
      default: '',
      displayWhen: [
        {
          field: 'conditionType',
          operator: 'IN',
          value: ['hasClaim', 'doesNotHaveClaim']
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ];

  elementProps = [
    {
      label: 'Friendly Name',
      name: 'identifier',
      editor: 'textbox',
      description: 'A friendly name for this element',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    ...elementProps
  ];

  //if (['text', 'image'].some(name => name === elementInstance.name)) {
  elementProps = [...elementProps, ...conditionalDisplayFields];
  //}

  elementProps.forEach(property => {
    const field = {
      enableCustomLabel: true,
      customLabel: '',
      editable: true,
      type: 'text',
      editor: 'text',

      displayConditions: []
    };

    let sourceProperty = property;

    if (!sourceProperty.name) {
      sourceProperty = elements.base.properties.find(p => p.name === property);
    }

    if (sourceProperty.name === 'fontFamily') {
      field.options = [{ label: '<Not Set>', value: '' }, ...fonts];
    }

    field.name = sourceProperty.name;
    field.customLabel = sourceProperty.label;
    field.customDescription = sourceProperty.description;
    field.editor = sourceProperty.editor;
    field.editable = true;
    field.valueKey = sourceProperty.valueKey;
    field.group = sourceProperty.group;
    field.description = `[${sourceProperty.name}] ${sourceProperty.description}`;
    field.mediaLibraryStoreIn = sourceProperty.mediaLibraryStoreIn;
    field.mediaLibraryPath = sourceProperty.mediaLibraryPath;
    field.allowMultipleUploads = sourceProperty.allowMultipleUploads;
    field.maximumUploads = 0;
    field.whenSelected = sourceProperty.whenSelected;

    if (property.options) {
      field.options = property.options;
    }

    if (
      [
        'layout',
        'layoutTabletLandscape',
        'layoutTabletPortrait',
        'layoutPhoneLandscape',
        'layoutPhonePortrait'
      ].some(f => f === field.name)
    ) {
      const filteredItems = document.elements
        ? document.elements
            ?.filter(e => e.name === 'layout')
            .map(e => {
              let orientations = '';
              if (e.useOnTabletInPortrait && !e.useOnTabletInLandscape) {
                orientations += 'Tablet (Portait) ';
              } else if (!e.useOnTabletInPortrait && e.useOnTabletInLandscape) {
                orientations += 'Tablet (Landscape) ';
              } else if (e.useOnTabletInPortrait && e.useOnTabletInLandscape) {
                orientations += 'Tablet (Portait, Landscape) ';
              }
              if (e.useOnPhoneInPortrait && !e.useOnPhoneInLandscape) {
                orientations += 'Phone (Portait) ';
              } else if (!e.useOnPhoneInPortrait && e.useOnPhoneInLandscape) {
                orientations += 'Phone (Landscape) ';
              } else if (e.useOnPhoneInPortrait && e.useOnPhoneInLandscape) {
                orientations += 'Phone (Portait, Landscape) ';
              }
              if (orientations === '') {
                orientations = 'No Orientations Specified!';
              }
              return {
                label: `${e.text} - ${orientations}`,
                value: e.id
              };
            })
        : [];
      field.options = [{ label: '<Not Set>', value: ' ' }, ...filteredItems];
    }

    if (property.function) {
      field.function = property.function;
    }

    const hasDisplayConditionMatch = condition => {
      let obj = elementInstance;
      if (condition.field.indexOf('document.') > -1) {
        obj = document;
      }
      const field = condition.field.replace('document.', '');
      if (condition.operator === 'DOES_NOT_START_WITH') {
        return obj[field].indexOf(condition.value) !== 0;
      } else if (condition.operator === 'IN') {
        return condition.value.some(s => s === obj[field]);
      } else if (condition.operator === 'NOT_IN') {
        return !condition.value.some(s => s === obj[field]);
      } else if (condition.operator === 'IS_NOT_EMPTY') {
        return obj[field] !== undefined && obj[field] !== '';
      } else if (
        condition.operator === 'DOES_NOT_EQUAL' ||
        condition.operator === '!==' ||
        condition.operator === '!='
      ) {
        return obj[field] !== condition.value;
      } else if (condition.operator === 'IS_EMPTY') {
        return obj[field] === undefined || obj[field] === '';
      } else if (condition.operator === 'STARTS_WITH') {
        if (isArray(condition.value)) {
          return condition.value.some(c => obj[field].indexOf(c) === 0);
        } else {
          return obj[field].indexOf(condition.value) === 0;
        }
      } else {
        return obj[condition.field] === condition.value;
      }
    };

    if (property.displayWhen) {
      let shouldDisplay = false;
      if (property.displayWhen.some(c => c.combine === 'OR')) {
        shouldDisplay = property.displayWhen.some(condition =>
          hasDisplayConditionMatch(condition)
        );
      } else {
        shouldDisplay = property.displayWhen.every(condition =>
          hasDisplayConditionMatch(condition)
        );
      }

      if (shouldDisplay) {
        fields.push(field);
      }
    } else {
      fields.push(field);
    }
  });

  return fields;
};

export {
  elements,
  buildElement,
  buildElementFormFields,
  ELEMENT_GROUPS,
  ELEMENT_ATTRIBUTE_GROUP
};
